import React, { FC } from 'react';

import { useTeamsCreatorDispatch, useTeamsCreatorState } from '../../Context/TeamsCreator.context';
import { TeamsCreatorPlayerSelector } from '../TeamsCreatorPlayerSelector/TeamsCreatorPlayerSelector';
import { Modal } from '../../../../../../components/Modal';

export const TeamPlayerSelectorModal: FC = () => {
  const { displayTeamPlayerSelectorModal: teamPlayerSelectorModal } = useTeamsCreatorState();
  const { dispatch } = useTeamsCreatorDispatch();

  const close = () => dispatch({ type: 'closeTeamPlayerSelectorModal' });

  return (
    <Modal onClose={close} open={teamPlayerSelectorModal} className="group-removal-modal">
      <TeamsCreatorPlayerSelector />
    </Modal>
  );
};
